import { useMemo } from "react";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Container } from "@remo-co/ui-core/src/components/Container";
import classNames from "classnames";
import { useI18n } from "i18n";
import { IEvent } from "modules/event/types";
import { useStyles } from "../Menu/styles";
import MenuItem from "./MenuItem";
import PreviewEmptyMenuItem from "./PreviewEmptyMenuItem";

interface IPreviewMenuProps {
  events: (IEvent | null)[];
  currentEventId: string | null;
}

const PreviewMenu = ({ events, currentEventId }: IPreviewMenuProps) => {
  const { t } = useI18n(["eventDirectory"]);
  const styles = useStyles();

  const availableEvents = useMemo(
    () =>
      events.filter(
        (event) => event === null || (event && event.id !== currentEventId),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [events],
  );

  return (
    <Card
      size="xs"
      flex={false}
      fullWidth={false}
      className={classNames(styles.card, styles.cardMenuVisible)}
    >
      <Container className={styles.container}>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          className={styles.goToRelatedEvents}
        >
          {t("event:top.bar.other.related.events")}
        </Typography>
      </Container>

      {availableEvents.map((event) =>
        event ? (
          <MenuItem
            event={event}
            currentEventId={null}
            preview
            menuDialogStyle={styles.dialog}
          />
        ) : (
          <PreviewEmptyMenuItem />
        ),
      )}
    </Card>
  );
};

export default PreviewMenu;
